<template>
    <a-form class='pop-common-form bind-form' :form="registerForm" @submit="handleSubmit">
        <a-form-item class="form-item" label="手机号" :colon="false" v-bind="formItemLayoutCenter" hasFeedback>
            <Input v-decorator="['phone',
            {
                rules: rules.phone,
            }
            ]"
            placeholder="请输入您的手机号码" maxLength=11
            />
        </a-form-item>
        <PhoneSMS :isSendCode.sync="isSendCode" :phone="phone" @resetCode="getNewCode" type="2" serviceType="REG"/>
        <a-form-item class="form-item" label="昵称" :colon="false" v-bind="formItemLayoutCenter" hasFeedback>
            <Input v-decorator="['nickName',{
                validate: [
                    {
                        trigger: 'blur',
                        rules: rules.nickName
                    },
                ]
            }]"
            placeholder="请输入昵称"
            />
        </a-form-item>
        <a-form-item class="form-item" label="登录密码" :colon="false" v-bind="formItemLayoutCenter" hasFeedback>
            <Input type="password" v-decorator="['password',
            {
                rules: rules.password,
                validateFirst: true
            }
            ]"
            placeholder="请输入密码"
            />
        </a-form-item>
        <a-form-item class="form-item" label="密码确认" :colon="false" v-bind="formItemLayoutCenter" hasFeedback>
            <Input type="password" v-decorator="['confirmPassword',
                {
                    rules: rules.confirmPassword,
                    validateFirst: true
                }
                ]"
                placeholder="请再次输入密码"
            />
        </a-form-item>
        <a-form-item v-bind="tailFormItemLayout">
            <Button class="form-button" type="primary" html-type="submit" :disabled="isDisable">提交</Button>
        </a-form-item>
    </a-form>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { Input, Button } from 'ant-design-vue'
import cookie from 'js-cookie'
import { Base64 } from 'js-base64';
import PhoneSMS from '@components/sendsms/sendmobile/index'
import FormUtil from '@utils/form'
import FormMix from '@auth/register/formMixins'
import { sessionStore } from '@shared/utils';

export default {
    data() {
        return {
            identity: '',
            appCode: '',
            appServiceCode: '',
            form: {},
            isSendCode: false,
            phone: ''
        }
    },
    mixins: [FormUtil, FormMix],
    methods: {
        ...mapMutations('register', ['setRegInfo']),
        handleSubmit(e) {
            e.preventDefault();
            this.registerForm.validateFields((error, values) => {
                if (!error) {
                    this.register()
                }
                return;
            });
        },
        getNewCode() {
            this.phone = this.registerForm.getFieldValue('phone')
            this.isSendCode = true
        },
        async register() {
            const info = {
                phone: this.registerForm.getFieldValue('phone'),
                nickName: this.registerForm.getFieldValue('nickName'),
                buzzCode: cookie.get('buzzCode'),
            }

            const param = {
                ...info,
                regType: 1,
                password: this.registerForm.getFieldValue('password'), 
                pwdConfirm: this.registerForm.getFieldValue('confirmPassword'), 
                buzzType: cookie.get('buzzType'),
                buzzId: cookie.get('buzzId'),
                buzzName: Base64.decode(cookie.get('buzzName'))
            }
            // console.log(param)
            const json = await this.$store.dispatch('register/doRegister', param)
            if (json.code * 1 === 1) {
                sessionStore.setItem('bindMobile', JSON.stringify(info))
                this.$router.push({
                    name: 'bindMobile',
                    query: {
                        type: 1
                    }
                })
            } else {
                this.$message.error(json.msg || '绑定手机时发生错误')
            }
        },
        compareToFirstPassword (rule, value, callback){
            if (value && this.registerForm.getFieldValue('password') && value !== this.registerForm.getFieldValue('password')) {
                callback('两次密码输入不一致');
            } else {
                callback();
            }
        },
        async validateName(rule, value, cb) {
            if (value) {
                const flag = await this.validNickName(value)
                if (!flag) {
                    cb('账户昵称需唯一')
                } 
            }
            cb()
        },
    },
    components: {
        Input,
        Button,
        PhoneSMS
    }
}
</script>
<style lang="scss">
.bind-form{
    margin-top: 40px;

    .ant-btn-primary{
        width: 260px;
    }
}
</style>
